import Icons from "../../../assets/js/Icons";

export const memberMenus = [
  {
    name: "dashboard",
    icon: <Icons.User1 />,
    path: "/member/profile",
  },
  {
    name: "my appointments",
    icon: <Icons.CalendarSolid />,
    path: "/member/profile/appointment/upcoming",

  },
  {
    name: "payments",
    icon: <Icons.Receipt />,
    path: "/member/profile/payments",
  },
  {
    name: "My Subscriptions",
    icon: <Icons.SaleTagSolid />,
    path: "/member/profile/subscription",
  },
  {
    name: "my specialist",
    icon: <Icons.CalendarSolid />,
    path: "/member/profile/specialists",
  },
  {
    name: "add forum",
    icon: <Icons.ForumAdd />,
    path: "/member/profile/add-forum",
  },
  {
    name: "forum posts",
    icon: <Icons.ForumAll />,
    path: "/member/profile/all-forum",
  },
  {
    name: "forum comments",
    icon: <Icons.ForumBookmark />,
    path: "/member/profile/forum-comments",
  },
  {
    name: "forum likes",
    icon: <Icons.ForumLike />,
    path: "/member/profile/forum-likes",
  },
  {
    name: "blog comments",
    icon: <Icons.Comment />,
    path: "/member/profile/blog-comments",
  },
  {
    name: "booked webinars",
    icon: <Icons.ConferenceSolidStandard />,
    path: "/member/profile/booked-webinar/upcoming",
  },
  {
    name: "my draft",
    icon: <Icons.Draft />,
    path: "/member/profile/draft",
  },
  {
    name: "messages",
    icon: <Icons.Comment1 />,
    path: "/member/profile/messages",
  },
  {
    name: "appointment chat",
    icon: <Icons.Comment1 />,
    path: "/member/profile/appointment-messages",
  },
  {
    name: "change password",
    icon: <Icons.ResetPassword />,
    path: "/member/profile/change-password",
  },
]

export const specialistMenus = [
  {
    name: "dashboard",
    icon: <Icons.User1 />,
    path: "/specialist/profile",
  },
  {
    name: "earnings & payouts",
    icon: <Icons.Receipt />,
    path: "/specialist/profile/wallet",
  },
  {
    name: "chat availability",
    icon: <Icons.CalendarSolid />,
    path: "/specialist/profile/availability",
  },
  {
    name: "schedule slot timing",
    icon: <Icons.ForumAdd />,
    path: "/specialist/profile/schedules",
  },
  {
    name: "appointment",
    icon: <Icons.ForumAdd />,
    path: "/specialist/profile/appointments/upcoming",
  }, {
    name: "my members",
    icon: <Icons.ForumAdd />,
    path: "/specialist/profile/members",
  },
  {
    name: "add forum",
    icon: <Icons.ForumAdd />,
    path: "/specialist/profile/add-forum",
  },
  {
    name: "forum posts",
    icon: <Icons.ForumAll />,
    path: "/specialist/profile/all-forum",
  },
  {
    name: "forum comments",
    icon: <Icons.ForumBookmark />,
    path: "/specialist/profile/forum-comments",
  },
  {
    name: "forum likes",
    icon: <Icons.ForumLike />,
    path: "/specialist/profile/forum-likes",
  },
  {
    name: "add blog",
    icon: <Icons.Comment />,
    path: "/specialist/profile/add-blog",
  },
  {
    name: "blog posts",
    icon: <Icons.Comment />,
    path: "/specialist/profile/all-blog",
  },
  {
    name: "blog comments",
    icon: <Icons.Comment />,
    path: "/specialist/profile/blog-comments",
  },
  {
    name: "add webinar",
    path: "/specialist/profile/add-webinar",
    icon: <Icons.ConferenceSolidStandard />,
  },
  {
    name: "webinars list",
    icon: <Icons.ConferenceSolidStandard />,
    path: "/specialist/profile/webinars/upcoming",
  },
  {
    name: "booked webinars",
    icon: <Icons.ConferenceSolidStandard />,
    path: "/specialist/profile/booked-webinar/upcoming",
  },
  {
    name: "specialist booked webinar",
    icon: <Icons.ConferenceSolidStandard />,
    path: "/specialist/profile/specialist-booked-webinar/upcoming",
  },
  {
    name: "my draft",
    icon: <Icons.Draft />,
    path: "/specialist/profile/draft",
  },
  {
    name: "messages",
    icon: <Icons.Comment1 />,
    path: "/specialist/profile/messages",
  },
  {
    name: "appointment chat",
    icon: <Icons.Comment1 />,
    path: "/specialist/profile/appointment-messages",
  },
  {
    name: "change password",
    icon: <Icons.ResetPassword />,
    path: "/specialist/profile/change-password",
  }
]